export default __webpack_public_path__ + "70e798a5.svg";